import React from "react";
import { CalendarCheck, Mail } from "lucide-react";
import { Reveal } from "../components/site/Reveal";

export const CTA = () => {
  const go = (h) => document.querySelector(h)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="relative overflow-hidden bg-emerald-base py-20 sm:py-28" data-testid="cta-section">
      <div className="absolute -right-20 -top-20 h-80 w-80 rounded-full bg-gold/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-10 h-80 w-80 rounded-full bg-emerald-light/20 blur-3xl" />
      <div className="grain absolute inset-0" />
      <div className="relative z-10 mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <h2 className="font-serif text-4xl font-light leading-tight text-off-white sm:text-5xl lg:text-6xl">
            Ready to <span className="text-gradient-gold">Transform Performance?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-off-white/80 sm:text-lg">
            Whether you are seeking to improve organisational performance, strengthen your supply chain, adopt artificial
            intelligence, develop your people or accelerate your career, OnwardTranscends can help turn your ambition into
            a practical roadmap for success.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
            <button data-testid="cta-book-btn" onClick={() => go("#contact")}
              className="flex items-center justify-center gap-2 rounded-full bg-gold px-7 py-4 text-sm font-semibold text-emerald-darkest shadow-[0_10px_30px_rgba(212,175,55,0.35)] transition-transform duration-300 hover:-translate-y-1">
              <CalendarCheck size={18} /> Book a Consultation
            </button>
            <button data-testid="cta-contact-btn" onClick={() => go("#contact")}
              className="flex items-center justify-center gap-2 rounded-full border border-off-white/30 px-7 py-4 text-sm font-semibold text-off-white transition-colors duration-300 hover:border-gold hover:text-gold">
              <Mail size={18} /> Contact Us
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
